import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@bingads-webui-react/primitive';
import { getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
import { withScope, QueryParam } from '@bingads-webui-react/scope-service';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
// eslint-disable-next-line import/no-unresolved
import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import { getTags } from './uet-tags-repository';
import PageMenu from './page-menu';
import { UetTagTreeNodeChildRenderer } from './uet-tags-tree-node';

class UetTagsPageMenuInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tags: [],
      siteMap: props.siteMap,
    };
  }

  componentDidMount() {
    const { aid, cid: scopeCid } = this.props.scope.values;
    const { CurrentAccount } = this.props.serverContext;
    const cid = aid ? CurrentAccount.AdvertiserCustomerID : scopeCid;

    getTags(cid, aid).then((response) => {
      const Inactive = response.filter(tag => tag.TrackingStatus === 'Inactive' && !tag.IsReadOnly).sort((a, b) => a.Name.localeCompare(b.Name));
      const Unverified = response.filter(tag => tag.TrackingStatus === 'Unverified' && !tag.IsReadOnly).sort((a, b) => a.Name.localeCompare(b.Name));
      const Active = response.filter(tag => tag.TrackingStatus === 'Active' || tag.IsReadOnly).sort((a, b) => a.Name.localeCompare(b.Name));
      const tag = Inactive.concat(Unverified).concat(Active);
      this.setState({ tags: tag });
    });
  }

  getTreeNodesProps() {
    const uetTagsInTree =
      this.state.tags.map(tag => ({
        ...tag,
        iconHidden: true,
        isSelected: this.props.scope.values.tagId === tag.Id,
        hideFallback: () => this.setState({}),
      }));

    return {
      uetTagsInTree,
    };
  }

  render() {
    const {
      uetTagsInTree,
    } = this.getTreeNodesProps();

    const updateUrl = () => {
      this.props.scope.remove('tagId');
      this.props.scope.save();

      const queryParam = new QueryParam(this.props.scope.history.location, this.props.scope.history);
      this.props.scope.history.push({
        pathname: getRoutePathById(this.state.siteMap, 'uet-tag'),
        search: queryParam.stringify(),
      });
    };

    return (
      <div style={{ width: '164px', borderRight: 'solid 1px #e1dfdd' }}>
        <Button
          onClick={() => { updateUrl(); }}
          style={{
            width: 164,
            textAlign: 'left',
            backgroundColor: '#fff',
            borderTop: 0,
            borderLeft: 0,
            borderBottom: 0,
            borderRight: 'solid 1px #e1dfdd',
            fontWeight: 'normal',
            outline: 'none',
          }}
        >{this.props.i18n.getString(_TL_('All tags'))}
        </Button>
        <hr style={{
          marginTop: 0,
          marginBottom: 0,
          backgroundColor: '#B3B0AD',
          color: '#B3B0AD',
          height: '1px',
        }}
        />
        <PageMenu
          ariaLabel={this.props.i18n.getString(_TL_('UET Tag Tree Grid'))}
          treeNodes={uetTagsInTree}
          nodeChildRenderer={UetTagTreeNodeChildRenderer}
          perfMarker={this.props.perfMarker}
        />
      </div>
    );
  }
}

UetTagsPageMenuInternal.propTypes = {
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.shape({
      AdvertiserCustomerID: PropTypes.number,
    }).isRequired,
  }),
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      UETDashboard: PropTypes.bool.isRequired,
    }),
  }).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  siteMap: PropTypes.shape({}).isRequired,
  perfMarker: PropTypes.isRequired,
};

UetTagsPageMenuInternal.defaultProps = {
  serverContext: {},
};

export const UetTagsPageMenu = withServerContext(withI18nConsumer(withScope(UetTagsPageMenuInternal)));
